package de.ohhhmhhh.backend.sdk.text

import de.ohhhmhhh.backend.models.model.text.InsertStaticTextRevisionRequest
import de.ohhhmhhh.backend.models.model.text.StaticTextEntity
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*

class TextServiceImpl(
    private val client: HttpClient
) : TextService {
    override suspend fun getAll(): List<StaticTextEntity> {
        return client.get("/texts").body()
    }

    override suspend fun getRevisions(id: String): List<StaticTextEntity> {
        return client.get("/texts/$id").body()
    }

    override suspend fun addRevision(request: InsertStaticTextRevisionRequest) {
        client.post("/texts/${request.id}") {
            setBody(request)
        }
    }
}